import { DateTime } from 'luxon';

import { JOB_TYPES } from '../../../../../types';

/**
 * Represents a request to estimate a job
 * Based on the PHP EstimateJobRequest class
 */
export class EstimateJobRequest {
    constructor(
        /**
         * The type of job (one-time or ongoing)
         * Must be one of the available job types
         * @example 'One-time'
         */
        public readonly job_type: JOB_TYPES,
        /**
         * Start datetime of the job in ISO8601 format
         * Must be today or later
         * @example '2025-04-28T12:34:56Z'
         */
        public readonly start_datetime: DateTime,
        /**
         * Number of hours for the job
         * Must be at least 4 and cannot exceed 48 for one-time job and 24 for ongoing job
         * @example 4
         */
        public readonly number_of_hours: number
    ) {
        // Validate job_type
        if (!Object.values(JOB_TYPES).includes(job_type)) {
            throw new Error(`Job type must be one of: ${Object.values(JOB_TYPES).join(', ')}`);
        }

        // Validate start_datetime
        const today = DateTime.now().startOf('day');
        if (start_datetime < today) {
            throw new Error('Start datetime must be today or later');
        }

        // Validate number_of_hours
        if (number_of_hours < 4) {
            throw new Error('Number of hours must be at least 4');
        }

        if (job_type === JOB_TYPES.ONE_TIME && number_of_hours > 48) {
            throw new Error('Number of hours cannot exceed 48 for one-time job');
        }

        if (job_type === JOB_TYPES.ONGOING && number_of_hours > 24) {
            throw new Error('Number of hours cannot exceed 24 for ongoing job');
        }
    }
}
